<template>
  <div v-if="originLoginType === 'assur_cc' && !isTestMechanic">
    <AssurCC :mechanicName="mechanicName" :mechanicGarage="mechanicGarage" :mechanicCode="mechanicCode"
      :monthlyQuoteCommissionBalances="monthlyQuoteCommissionBalances" @requestWire="requestWire" />
  </div>
  <div v-else-if="originLoginType === 'garanties_mechanics' && !isTestMechanic">
    <GarantiesMechanic :mechanicName="mechanicName" :mechanicGarage="mechanicGarage" :mechanicCode="mechanicCode"
      :monthlyQuoteCommissionBalances="monthlyQuoteCommissionBalances" @requestWire="requestWire" />
  </div>
  <div v-else-if="originLoginType === 'dynassurances' && $can('read', 'account_representative') && !isTestMechanic">
    <Dynassurances :mechanicName="mechanicName" :mechanicGarage="representativeName"
      :monthlyQuoteCommissionBalances="monthlyQuoteCommissionBalances" @requestWire="requestWire" />
  </div>
  <div v-else-if="originLoginType === 'dynassurances' && mechanicCode != '705223' && !isTestMechanic">
    <Dynassurances :mechanicName="mechanicName" :mechanicGarage="mechanicGarage" :mechanicCode="mechanicCode"
      :monthlyQuoteCommissionBalances="monthlyQuoteCommissionBalances" @requestWire="requestWire" />
  </div>
  <div v-else-if="originLoginType === 'dynassurances' || originLoginType === 'garanties_mechanics' && isTestMechanic">
    <DynassurancesV2 :mechanicName="mechanicName" :mechanicGarage="mechanicGarage" :mechanicCode="mechanicCode"
      :monthlyQuoteCommissionBalances="monthlyQuoteCommissionBalances" @requestWire="requestWire" />
  </div>
  <div v-else>
    <div class="header">
      <div class="container-fluid">
        <div class="header__content">
          <div class="header__content__logo">
            <!--              <a :href="dynassurancesUrl" class="logo__image">-->
            <!--                <img src="../assets/logo.gif"-->
            <!--                     alt="Dynassurances : L'assurance d'&ecirc;tre bien assur&eacute;"-->
            <!--                     width="286" height="105"-->
            <!--                     title="Dynassurances : L'assurance d'&ecirc;tre bien assur&eacute;"/>-->
            <!--              </a>-->
          </div>
          <div class="header__greetings">{{ greetings }}</div>
          <div class="header__content__account">
            <a href="" class="dropdown-toggle" id="headerDropDown" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              <div class="header__content__account__avatar">
                <img src="../assets/avatar-default-white.png" alt="">
              </div>
              <div class="header__content__account__avatar--name">{{ mechanicName }}</div>
            </a>
            <div class="header__content__account__name">
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="headerDropDown">
                <router-link class="dropdown-item" to="/my-account-representative"
                  v-if="$can('read', 'account_representative') && !isMutuaideCommercial">
                  <span>Mon compte</span>
                </router-link>
                <router-link class="dropdown-item" to="/my-account" v-else-if="!$can('read', 'account_representative')">
                  <span>Mon compte</span>
                </router-link>
                <router-link class="dropdown-item" to="/my-documents"
                  v-if="$can('read', 'account_representative') && !isMutuaideCommercial">
                  <span>Mes documents</span>
                </router-link>
                <a href="#" class="dropdown-item" @click="$root.logOut">
                  <span>Deconnexion</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import AssurCC from "./Headers/AssurCC";
import GarantiesMechanic from "./Headers/GarantiesMechanic";
import Dynassurances from "./Headers/Dynassurances";
import DynassurancesV2 from "./Headers/v2/Dynassurances";
const GLOBAL_URL = 'http://dynassurances.fr/';

export default {
  name: 'Header',
  components: { Dynassurances, GarantiesMechanic, AssurCC, DynassurancesV2 },
  data() {
    return {
      home_page: GLOBAL_URL
    }
  },
  computed: {
    isTestMechanic() {
      return this.$store.getters.isTest;
    },
    mechanicName() {
      let full_name = this.$store.state.userInfo.first_name;
      return full_name ? full_name : '';
    },
    mechanicGarage() {
      let garage = (this.$store.state.userInfo && this.$store.state.userInfo.mechanic) ? this.$store.state.userInfo.mechanic.garage : null;
      return garage ? garage : '';
    },
    mechanicCode() {
      let code = (this.$store.state.userInfo && this.$store.state.userInfo.mechanic) ? this.$store.state.userInfo.mechanic.code : null;
      return code ? code : '';
    },
    representativeName() {
      let name = (this.$store.state.userInfo && this.$store.state.userInfo.representative) ? this.$store.state.userInfo.representative.name : null;
      return name ? name : '';
    },
    greetings() {
      let code = this.$store.state.userInfo.mechanic && this.$store.state.userInfo.mechanic.code ? this.$store.state.userInfo.mechanic.code : '';
      let garage = this.$store.state.userInfo.mechanic && this.$store.state.userInfo.mechanic.garage ? this.$store.state.userInfo.mechanic.garage : '';
      return this.$store.state.userInfo.mechanic && garage && code ? `Bienvenue ${garage} - ${code}` : '';
    },
    originLoginType() {
      return this.$store.state.userInfo.origin_login || 'dynassurances';
    },
    dynassurancesUrl() {
      return this.$store.state.dynassurances_web_site_url
    },
    isMutuaideCommercial() {
      return this.$store.getters.isRepresentative && (this.$store.getters.getRepresentative.id == 15);
    },
    monthlyQuoteCommissionBalances() {
      let balances = {
        reserved: 0.00,
        available: 0.00
      };
      if (this.$store.getters.isClientMonthlyPayment) {
        balances.reserved = this.$store.state.userInfo.mechanic && this.$store.state.userInfo.mechanic.mqc_balance_reserved ? parseFloat(this.$store.state.userInfo.mechanic.mqc_balance_reserved).toFixed(2) : 0.00;
        balances.available = this.$store.state.userInfo.mechanic && this.$store.state.userInfo.mechanic.mqc_balance_available ? parseFloat(this.$store.state.userInfo.mechanic.mqc_balance_available).toFixed(2) : 0.00;
      }
      return balances;
    }
  },
  methods: {
    requestWire() {
      this.toggleVirementButtonLoader(true);
      let url = `${this.$store.state.userInfo.mechanic.id}/commissions-mensuelles/wire-request`;
      this.apiPost(url, {})
        .then((response) => {
          this.toggleVirementButtonLoader(false);
          if (response.data && response.data.status === 'success') {
            if (response.data.available || response.data.available == 0) {
              this.$store.state.userInfo.mechanic.mqc_balance_available = response.data.available;
            }
            if (response.data.reserved || response.data.reserved == 0) {
              this.$store.state.userInfo.mechanic.mqc_balance_reserved = response.data.reserved;
            }
            this.showSuccessNotification("Le virement a été demandé avec succès.");
          } else if (response.data && response.data.status === 'error') {
            if (response.data.message) {
              this.showErrorNotification(response.data.message);
            } else {
              this.showErrorNotification("Impossible de créer la virement de commission.");
            }
          } else {
            this.showErrorNotification("Une erreur est survenue.");
          }
        })
        .catch(error => {
          this.showErrorNotification(error);
          this.toggleVirementButtonLoader(false);
        });
    },
    toggleVirementButtonLoader(on = false) {
      let vb = document.querySelectorAll('.virement-button');
      if (on) {
        vb.forEach((button) => {
          button.querySelector('.vb-icon').classList.remove('d-none');
          button.querySelector('.vb-text').classList.add('d-none');
        });
      } else {
        vb.forEach((button) => {
          button.querySelector('.vb-icon').classList.add('d-none');
          button.querySelector('.vb-text').classList.remove('d-none');
        });
      }
    }
  },
  mounted() {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue